import type {ReactElement} from 'react';
import {useEffect, useState} from 'react';
import {Icon} from '@Components/icon-v2';
import {IconSize} from '@Components/icon-v2/icon.types';
import {getUserPremiumLevel, isUserLoggedIn} from '@Libraries/user.library';
import {readCookie} from '@Utils/cookie.util';
import {NEW_MOBILE_UX_COOKIE, NEW_MOBILE_UX_HAS_SEEN_VALUE_LIMIT} from '@Components/poster-editor/components/editor-mobile-onboarding/editor-mobile-onboarding.types';
import ClickableDiv from '@Components/clickable-div/clickable-div';
import {isPAYGUser} from '@Utils/user.util';
import styles from './add-button.module.scss';

interface AddButtonProps {
  id?: string;
  className?: string;
  iconSize?: IconSize;
  onClick(): void;
}

const SHINE_ANIMATION_DURATION = 10700;
const SHINE_ANIMATION_COUNT = 3;

export function AddButton({id = '', className = '', iconSize = IconSize.SIZE_ICON_20, ...props}: AddButtonProps): ReactElement<any> {
  const [showShineAnimation, setShowShineAnimation] = useState(false);

  useEffect((): void => {
    toggleAnimation();
  }, []);

  const doShowAddAnimation = (): boolean => {
    const isLoggedIn = isUserLoggedIn();
    if (isLoggedIn && !isPAYGUser(getUserPremiumLevel())) {
      return false;
    }

    if (isLoggedIn) {
      return window.posterEditor?.config?.showMobileUXOnBoarding ?? false;
    }

    const value = readCookie(NEW_MOBILE_UX_COOKIE);

    const hasSeenValue = Number(value);
    return hasSeenValue < NEW_MOBILE_UX_HAS_SEEN_VALUE_LIMIT;
  };

  const toggleAnimation = (): void => {
    if (!doShowAddAnimation()) {
      return;
    }

    const interval = setInterval((): void => {
      handleAnimationStartAndEnd();
    }, SHINE_ANIMATION_DURATION);

    setTimeout((): void => {
      clearInterval(interval);
    }, SHINE_ANIMATION_COUNT * SHINE_ANIMATION_DURATION);
  };

  const handleAnimationStartAndEnd = (): void => {
    setShowShineAnimation(true);

    setTimeout((): void => {
      setShowShineAnimation(false);
    }, 700);
  };

  return (
    <ClickableDiv
      id={id}
      className={`${className} ${styles.button} flex-center radius-round ${showShineAnimation ? styles.shineAnimation : ''}`}
      onClick={(): void => {
        props.onClick();
      }}
    >
      <Icon icon="icon-plus" size={iconSize} className="content-body-white" />
    </ClickableDiv>
  );
}
